export default (createInitialState) =>
  (state) => {
    const newState = createInitialState()
    for (const key of Object.keys(newState)) {
      state[key] = newState[key]
    }
  }
